import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Play } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
      {/* Background gradient blob */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-96 h-96 lg:w-[600px] lg:h-[600px] bg-gradient-to-br from-blue-400 via-purple-500 to-pink-400 rounded-full blur-3xl opacity-20 animate-pulse"></div>
      </div>
      
      {/* Floating elements */}
      <div className="absolute top-20 left-10 w-2 h-2 bg-purple-400 rounded-full opacity-60 animate-bounce"></div>
      <div className="absolute top-32 right-20 w-3 h-3 bg-blue-400 rounded-full opacity-60 animate-bounce delay-300"></div>
      <div className="absolute bottom-40 left-20 w-2 h-2 bg-pink-400 rounded-full opacity-60 animate-bounce delay-500"></div>
      <div className="absolute bottom-20 right-10 w-4 h-4 bg-purple-300 rounded-full opacity-60 animate-bounce delay-700"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-purple-50 border border-purple-200 rounded-full text-sm text-purple-600 mb-8">
            <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
            Descubre cómo automatizar tu empresa con IA en 30 minutos
          </div>

          {/* Main headline */}
          <h1 className="text-4xl lg:text-7xl font-bold text-gray-800 leading-tight mb-6">
            <span className="block">Automatiza tu empresa con</span>
            <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              IA personalizada
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto mb-8 leading-relaxed">
            Desarrollamos sistemas inteligentes que trabajan 24/7 para tu negocio, liberando tu tiempo para lo que realmente importa.
          </p>

          {/* Subtitle */}
          <p className="text-base text-gray-500 mb-10">
            Descubre el potencial de tu empresa en una consulta personalizada
          </p>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              onClick={() => window.open('https://cal.com/peter-gal/30min?overlayCalendar=true', '_blank')}
            >
              Hablemos
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            
            <Button 
              variant="ghost" 
              size="lg"
              className="text-gray-600 hover:text-gray-800 px-8 py-4 font-semibold text-lg"
              onClick={() => window.location.href = '/demo'}
            >
              <Play className="mr-2 h-5 w-5" />
              Probar demo
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;